import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from 'app/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AccountGuard implements CanActivateChild {

  constructor(
    private auth : AuthService,
    private router : Router
  ){
    
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean{
    const val = this.auth.getSession();
    if (!val.value) {
      return true;
    } else {
      this.router.navigate(['/login']);
      return false;
    }
  }
}
